import { CookieModule, LoggerModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";

import { UserService } from "./user.service";

export const UserModule: Module = {
  name: "UserModule",
  modules: [CookieModule, LoggerModule],
  providers: [UserService],
};
